import { get, writable } from "svelte/store";
import axios from "axios";
import LoadState from "../Enums/LoadState";

const CountryPolygons = {
	meta: {
		loadState: writable(LoadState.INIT),
		error: writable("")
	},
	results: {
		data: null,
		lookup: {}
	}
};
CountryPolygons.getCountryFeature = (cc) => {
	if (cc === "") {
		return null;
	}
	return CountryPolygons.results.lookup[cc];
};

CountryPolygons.get = () => {
	return new Promise((resolve, reject) => {
		CountryPolygons.load((data) => {
			resolve(data);
		}, (error) => {
			reject(error);
		});
	});
};
CountryPolygons.load = (successCallback, errorCallback) => {
	if (get(CountryPolygons.meta.loadState) === LoadState.LOADED) {
		successCallback(CountryPolygons.results.data);
		return;
	}
	CountryPolygons.meta.error.set("");
	CountryPolygons.meta.loadState.set(LoadState.LOADING);

	const fileUrl = window.location.origin + "/files/_country_polygons.json";
	axios.get(fileUrl)
		.then(response => {
			return { success: (response.status === 200), data: response.data };
		})
		.then((response) => {
			if (!response.success) {
				throw new Error(response);
			}
			CountryPolygons.results.data = response.data;

			for (let i = 0; i < CountryPolygons.results.data.features.length; i++) {
				const f = CountryPolygons.results.data.features[i];
				CountryPolygons.results.lookup[f.properties.cc] = f;
			}

			CountryPolygons.meta.loadState.set(LoadState.LOADED);

			successCallback(CountryPolygons.results.data);
		})
		.catch(error => {
			console.error("country polygons failed", error);
			CountryPolygons.meta.error.set(error);
			CountryPolygons.meta.loadState.set(LoadState.INIT);

			errorCallback(error);
		});
};
export default CountryPolygons;
